module.exports = __webpack_public_path__ + "static/img/face-angry.43632a6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/face-angry.gif
// module id = s0LP
// module chunks = 0